// extracted by mini-css-extract-plugin
module.exports = {"logo":"appLogo_logo__Bwv2L"};